import { useQuery } from '@tanstack/react-query';
import { getCsrfToken } from 'client/api/csrf';
import { getSFLItems } from 'client/api/save-for-later';
import useGlobalConfig from 'client/state/GlobalConfig';
import { ATGSFLGetItemsResponse } from 'common/types/ATGSFLResponse';
import { Product, SFLProduct } from 'common/types/search-response';
import { useCallback, useMemo } from 'react';

export const handleSFLData = (SFLItems: string) => {
  const parsedData = JSON.parse(SFLItems);
  const productIDs = parsedData.savedProducts?.map((product: SFLProduct) => product.productId);
  return productIDs;
};

export const useProductSFL = (productList?: Product[]) => {
  const { isLocal, brand } = useGlobalConfig();

  const { data: csrf } = useQuery({
    queryKey: ['csrf', isLocal],
    queryFn: getCsrfToken,
  });

  const { data: sflItems } = useQuery({
    queryKey: ['sfl', csrf?.csrfToken, isLocal],
    queryFn: getSFLItems,
    select: useCallback((d: ATGSFLGetItemsResponse) => d.savedProducts.map((p) => p.productId), []),
    // Conditionally disable the query when brand is "veryireland"
    enabled: Boolean(csrf?.csrfToken) && brand !== 'veryireland',
  });

  return useMemo(() => {
    if (!sflItems?.length || !productList?.length) return {};

    return productList.reduce((map, p) => {
      map[p.product_id] = sflItems.includes(p.product_id.toString());
      return map;
    }, {} as Record<number, boolean>);
  }, [productList, sflItems]);
};
